// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    GetUnfilteredProducts,
    PopulateApiParameter,
    RemoveNotAvailableAttributeValues,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        expand: (props.apiParameter.expand || []).concat("properties"),
    };

    if (props.apiParameter.categoryId) {
        props.apiParameter = {
            ...props.apiParameter,
            // this controls the showing products in category pages
            includeProductsInSubCategories: !!props.parameter?.includeProductsInSubCategories,
            // to show facets filters in category pages
            restrictAttributesToCategory: !!props.parameter?.restrictAttributesToCategory,
        };
    }
};

/** We should remove includeProductsInSubCategories from ApiParameter because this option need CategoryId
 * and GetUnfilteredProducts remove CategoryId from ApiParameter
 */
export const XngGetUnfilteredProducts: any = (props: any) => {
    if (!props.result.productFilters.pageCategoryId) {
        const apiParameter = { ...props.apiParameter };
        if (props.apiParameter.includeProductsInSubCategories) {
            delete apiParameter.includeProductsInSubCategories;
        }
        if (props.apiParameter.restrictAttributesToCategory) {
            delete apiParameter.restrictAttributesToCategory;
        }
        props.apiParameter = {
            ...apiParameter,
        };
    }
};

export const XngRemoveNotAvailableAttributeValues: any = (props: any) => {
    const productsDataView = getProductsDataView(props.getState(), props.apiParameter);
    // XNG-Changes: check if there is valid attributeTypeFacets
    // (opti issue here: productsDataView is not always returned correctly)
    if (!productsDataView.value || !productsDataView.attributeTypeFacets) {
        return;
    }
    // call original handler method:
    RemoveNotAvailableAttributeValues(props);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, RemoveNotAvailableAttributeValues, XngRemoveNotAvailableAttributeValues);
addToChainBefore(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
